import Marionette from "backbone.marionette";
import NavigationBehavior from "../../../../../behaviors/navigation";
import RoutableBehavior from "../../../../../behaviors/routable";
import Link from "../../../dropdown/link";
import Collection from "../../../../../collections/menu-items";

const CATEGORY = "top-menu";

const DEFAULTS = {
  childView: Link,
};

class Links extends Marionette.CollectionView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  behaviors() {
    return [
      { behaviorClass: RoutableBehavior },
      {
        behaviorClass: NavigationBehavior,
        category: CATEGORY,
      },
    ];
  }

  initialize() {
    this.collection = new Collection(this.model.getChildren());
  }
}

export { Links as default };
